var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarimg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.398,
    height: 18.342,
    viewBox: "0 0 28.398 18.342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "video-svgrepo-com_1_",
    "data-name": "video-svgrepo-com (1)",
    d: "M18.341,14.13l8.1-4.66c1.072-.628,1.959-.185,1.959,1.11V24.335c0,1.258-.887,1.775-1.959,1.147l-8.1-4.7v3.476a2.32,2.32,0,0,1-2.33,2.33H2.255A2.281,2.281,0,0,1,0,24.262V10.543A2.25,2.25,0,0,1,2.255,8.25H16.011a2.289,2.289,0,0,1,2.33,2.293Z",
    transform: "translate(0 -8.25)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarimg6);
export default __webpack_public_path__ + "static/media/sidebarimg6.295bc677e40660be0675d58383abfc6c.svg";
export { ForwardRef as ReactComponent };